import axios from "./jfetch"
import Vue from 'vue'
import buryFetch from "./buryfetch"
import { api } from '../config/configUrl'
import utils from '../utils/utils'
let statisToken = localStorage.getItem(process.env.VUE_APP_PREFIX + 'statisToken');
export default {
  //埋点相关接口
  getStatisToken: (params) => buryFetch.post(api.bury.getToken, params),
  getStatisClientinfo: (params) => buryFetch.post(api.bury.clientinfo + "?access_token=" + statisToken, params),
  getStatisCommon: (evtMethod, params, beforeDetail) => {
    // if(Vue.prototype.$routeLength === 1 && !params.entry){
    //   if(evtMethod === "evn_open_page" || evtMethod === "evn_dom_finish"){
    //     return
    //   }
    // }

    let ltime = 0
    if (evtMethod === "evn_open_page" || evtMethod === "evn_dom_finish") {
      ltime = new Date().getTime() - params.initTime;
    }
    let curl = params && params.curl || localStorage.getItem(process.env.VUE_APP_PREFIX + 'curl')
    buryFetch.post(api.bury.common, {
      "appn": localStorage.getItem('burryAppname') || "O2Owechatapp",
      "md": localStorage.getItem(process.env.VUE_APP_PREFIX + 'moduleName'),
      "sid": localStorage.getItem('burrySessionId'),
      "uid": localStorage.getItem(process.env.VUE_APP_PREFIX + 'memberId') || '',
      "curl": curl,
      "ev": evtMethod, //"evn_open_page"
      "ed": JSON.stringify(params.ed) || "",
      "time": new Date().getTime(),
      "h5Version": localStorage.getItem('h5Version') || '',
      "purl": beforeDetail || localStorage.getItem(process.env.VUE_APP_PREFIX + 'purl'),
      "ltime": params.ltime || ltime || 0,
      "woid": localStorage.getItem('oid') || ""
    })
  },
  //api接口
  goodsList: (params) => axios.get(api.member.list, params),
  getAreaList: (params) => axios.get(api.area.arealist, params),
  getShopList: (params) => axios.get(api.area.near, params),
  getMemberReceiverList: (params) => axios.get(api.area.getMemberReceiverList, params),
  // upsertMemberReceiver:(params) => axios.post(api.area.upsertMemberReceiver,params),
  getOrderList: (params) => axios.get(api.order.orderList, params),
  getOrderDetail: (params) => axios.get(api.order.orderDetail, params),
  cancelOrder: (params) => axios.get(api.order.orderCandel, params),
  delOrder: (params) => axios.get(api.order.orderDel, params),
  confirmReceipt: (params) => axios.get(api.order.confirmReceipt, params),
  logisticTrace: (params) => axios.get(api.order.logisticTrace, params),
  // getSettlementPage:(params) => axios.get(api.order.getSettlementPage,{params:params}),
  // getSettlementPage2:(params) => axios.get(api.order.getSettlementPage2,{params:params}),
  getSettlementPage: (params) => {
    if (params.pintuanId) {
      return axios.get(api.order.getSettlementPage2, { params: params })
    } else {
      // TODO:换 非拼团
      return axios.get(api.order.getSettlementPage, { params: params })
    }

  },
  // TODO:换
  createOrderInfo: params => axios.get(api.order.getSettlementPage2, { params: params }),
  // goodsList : (params) => axios.get(api.member.list,{params:params}),
  getMemberV1: (params) => axios.get(api.member.memberv1 + params),
  getPayCodeToken: (params) => axios.get(api.member.getPayCodeToken + params),
  toRefreshToken: (params) => axios.post(api.phoneLogin.toRefreshToken, params),
  // getBanner: (params) => axios.get(api.member.getBanner+"?category=member&positionId=4"),
  getMemberBanner: (params) => axios.get(api.member.getMemberBanner + "?category=member&positionId=6"),
  getHomeDetail: (params) => axios.get(api.member.getHomeDetail, params),
  getHomeSkuList: (params) => axios.post(api.member.getHomeSkuList, params),
  getCustomerBanner: (params) => axios.get(api.member.getCustomerBanner, params),
  androidVersionCode: (params) => axios.post(api.member.androidVersionCode, params),

  getDetail: (params) => axios.get(api.detail.detail, { params: params }),
  isAreaSel: (params) => axios.get(api.detail.isAreaSel, { params: params }),
  getSaleInventory: (params) => axios.get(api.detail.getSaleInventory, { params: params }),
  addCart: (params) => axios.get(api.detail.addCart, { params: params }),

  sendPhone: (params) => axios.get(api.phoneLogin.sendPhone + params),
  goLogin: (params) => axios.post(api.phoneLogin.goLogin, params),

  getMyPromotionCode: (params) => axios.get(api.myPromotion.backendUrlQRCode + params),
  getMyPromotionRefMemberId: (params) => axios.get(api.member.memberv1 + params),
  getMyPromotionInfo: (params) => axios.post(api.myPromotion.info, params),

  getTransactionsCount: (params) => axios.get(api.trans.transCount + params + "/transactions/count"),
  getTransactionsCancel: (params) => axios.get(api.trans.transCancel + params),
  getTransactionsList: (memberId, params) => axios.post(api.trans.transCount + memberId + "/transactions", params),
  getTransactionsDetail: (memberId, params) => axios.get(api.trans.transCount + memberId + "/transactions/" + params),
  backendUrlRequestment: (params) => axios.post(api.trans.backendUrlRequestment, params),

  getPointList: (memberId, params) => axios.post(api.point.pointList + memberId + "/point", params),
  getPointBalance: (params) => axios.get(api.point.pointList + params + "/point/balance"),
  getPointExpiration: (params) => axios.get(api.point.pointList + params + "/point/expiration"),

  getOrderPromotion: (params) => axios.get(api.orderConfirm.getOrderPromotion, { params: params }),
  upsertMemberReceiver: (params) => axios.post(api.orderConfirm.upsertMemberReceiver, params),
  createOrder: (params) => {
    if (params.createType === "collage") {
      return axios.post(api.orderConfirm.createOrder2, params)
    } else {
      return axios.post(api.orderConfirm.createOrder, params)
    }
  },
  /**
   * @description 新人专享专用下单接口
   * @param {*} param 
   * @returns 
   */
  createOrderNewer: param => axios.post(api.orderConfirm.Newer, param),
  userPointCheck: (params) => axios.get(api.orderConfirm.userPointCheck, { params: params }),
  cacheUserDepot: (params) => axios.get(api.orderConfirm.cacheUserDepot, { params: params }),

  getCustomerInfo: (params) => axios.get(api.my.getCustomerInfo),
  getReceiveOrderList: (params) => axios.get(api.my.getReceiveOrderList),
  getReceiveOrderNum: (params) => axios.get(api.my.getReceiveOrderNum),

  updateMemberV1: (params) => axios.put(api.member.memberv1, params),

  onlinePayment: (params) => axios.post(api.order.onlinePayment, params),
  paying: (params) => axios.get(api.order.paying, params),
  getPaymentMethodList: (params) => axios.get(api.order.getPaymentMethod, params),
  getOuterPage: (params) => axios.get("https://stg-mini-portal.jihuiduo.cn/#/activity/94"),

  getCategoryList: (params) => axios.get(api.category.list, params),
  getCategoryGoodsList: (params) => axios.post(api.category.goodsList, params),

  getCollageList: (params) => axios.get(api.collage.goodsList, { params: params }),
  getCollageItem: (params) => axios.get(api.collage.getItemPintuan, { params: params }),
  joinCollage: (params) => axios.post(api.collage.joinCollage, params),
  startCollage: (params) => axios.post(api.collage.startCollage, params),
  joinValidate: (params) => axios.post(api.collage.joinValidate, params),
  collageDetail: (params) => axios.get(api.collage.collageDetail, { params: params }),
  pintuanValidate: (params) => axios.get(api.collage.pintuanValidate, { params: params }),

  getShopCarList: (params) => axios.get(api.shopcar.list, params),
  getShopCarCheckbox: (params) => axios.get(api.shopcar.select, params),
  getShopCarAddDecrease: (params) => axios.get(api.shopcar.adddecrease, params),
  getShopCarDelete: (params) => axios.get(api.shopcar.delete, params),
  getShopCarNum: (params) => axios.get(api.shopcar.getNum, params),
  shopclearCache: (params) => axios.get(api.shopcar.shopclearCache, params),

  getPintuanList: (params) => axios.post(api.pintuan.popular, params),
  getNewStatus: () => axios.get(api.member.newUser),
  getNewerSkuList: param => axios.post(api.shopcar.newerSkuList, param),
  // 优惠券相关
  /**
   * @description 领劵中心列表
   * @param {Number|String} page 当前页码
   * @param {Number|String} pageSize 每页条数
   */
  centerList: (param = {}) => axios.post(api.coupon.center, param),
  /**
   * @description 领取优惠券
   * @param {Number|String} couponInfoId 优惠券id 
   */
  getCoupon: (param = {}) => axios.post(api.coupon.get, param),
  /**
   * @description 我的优惠券列表
   * @param {Number|String} page 当前页码
   * @param {Number|String} pageSize 每页条数
   * @param {Number} useState 列表状态 0.全部，1.未使用 ，2.已使用，3.已过期
   * @returns 
   */
  myCoupons: (param = {}) => axios.post(api.coupon.my, param),
  /**
   * @description 商品可用优惠券
   * @param {Number|String} couponProductEnum 类型，商品页，购物车页
   * @param {Number|String} itemId 商品id
   */
  usefulList: (param = {}) => axios.post(api.coupon.list, param),
  /**
   * @description 结算详情 新
   */
  getOrderInfo: (param = {}) => axios.post(api.coupon.orderInfo, param),
  /**
   * @description 订单提交 新
   * @param {Object} param 
   */
  orderSubmit: param => axios.post(api.coupon.orderSubmit, param),
  /**
   * @description 使用优惠券（选中）
   * @param {Object} param 
   */
  useCoupon: param => axios.post(api.coupon.use, param),
  /**
   * @description 获取优惠券轮播图
   * @returns 
   */
  couponBanner: () => axios.get(api.coupon.banner, {}),
  /**
   * @description 获取当前总优惠券数量
   * @returns 
   */
  getCouponTotal: () => axios.post(api.coupon.total, {}),
  /**
   * @description 搜索
   * @param {String} find 搜索关键字 
   * @param {Number} currentPage 查询页码
   * @param {Number} pageSize 每页条目数
   */
  search: param => axios.post(api.search.query, param),
  /**
   * @description 查询历史记录
   * @param {String|Number} customerId 用户id 
   */
  searchHistory: param => axios.post(api.search.history, param),
  /**
   * @description 同步历史搜索
   * @param {String|Number} customerId 用户id
   * @param {Array} records 历史记录数组 
   */
  searchRecord: param => axios.post(api.search.record, param),
  /**
   * @description 签到操作
   * @param {Object} param 
   * @returns 
   */
  getSignIn:param=>axios.post(api.signIn.geSignIn,param),
  /**
   * @description 进度详情
   * @param {Object} param 
   * @returns 
   */
  detail:param=>axios.post(api.signIn.detail,param),
  /**
   * @description 任务详情
   * @param {Object} param 
   * @returns 
   */
  task:param=>axios.post(api.signIn.task,param)

}